import { useState } from 'react';

/**
 * 浅色 / 深色（CR-081）。默认跟着系统走；手动选了就写在 <html data-theme> 上，`index.css` 按它换一套 token。
 *
 * **按设备记，不按人记**：手机是公司发的、几个人轮着用（CR-006），外观是这台手机的事；
 * 退出登录不清它（草稿要清，这个不用 —— 它不是谁的数据）。
 */
export type ThemePreference = 'system' | 'light' | 'dark';

const KEY = 'construction.theme';

export function readTheme(): ThemePreference {
  try {
    const value = localStorage.getItem(KEY);
    return value === 'light' || value === 'dark' ? value : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(preference: ThemePreference): void {
  const root = document.documentElement;
  if (preference === 'system') delete root.dataset.theme;
  else root.dataset.theme = preference;
}

export function useTheme(): [ThemePreference, (next: ThemePreference) => void] {
  const [preference, setPreference] = useState<ThemePreference>(readTheme);
  const set = (next: ThemePreference) => {
    try {
      if (next === 'system') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, next);
    } catch {
      // 隐私模式下存不了：这一次照样生效，下次回到跟随系统
    }
    applyTheme(next);
    setPreference(next);
  };
  return [preference, set];
}
